import * as React from 'react';

import { useApplicationContext } from '../../utils/applicationContext';

const DEFAULT_SLIDE_MS = 320;
const DEFAULT_HOLD_MS = 4000;
const DEFAULT_START_DELAY_MS = 700;
const DEFAULT_TEXT_FADE_MS = 300;

/**
 * Конфиг анимации онбординга свайпа-репляя. Задаётся одним ключом
 * `chats.replies.onboarding.swipeAnimationConfig`.
 */
export interface IOnboardingSwipeAnimationConfig {
  /** Задержка (мс) перед стартом онбординга */
  startDelayMs?: number;
  /** Длительность (мс) фазы сдвига */
  slideMs?: number;
  /** Длительность (мс) фазы удержания */
  holdMs?: number;
  /** Длительность (мс) появления/скрытия подсказки */
  textFadeMs?: number;
}

/**
 * Длительности фаз анимации свайпа (онбординг).
 * Берутся из RS-настройки chats.replies.onboarding.swipeAnimationConfig
 */
export const useOnboardingSwipeAnimationConfig = (): Required<IOnboardingSwipeAnimationConfig> => {
  const { config } = useApplicationContext();

  return React.useMemo(() => {
    const {
      startDelayMs = DEFAULT_START_DELAY_MS,
      slideMs = DEFAULT_SLIDE_MS,
      holdMs = DEFAULT_HOLD_MS,
      textFadeMs = DEFAULT_TEXT_FADE_MS,
    } = config.get<IOnboardingSwipeAnimationConfig | null>('chats.replies.onboarding.swipeAnimationConfig') ?? {};

    return {
      startDelayMs,
      slideMs,
      holdMs,
      textFadeMs,
    };
  }, [config]);
};
